__turbopack_context__.v({
  "consStyle": "jDicQq_consStyle",
  "prosStyle": "jDicQq_prosStyle",
});
